import {loader, getCatalogId, errorHandler, logout, message} from '@/libs/helper'
import {getMetaDossierList, followCollection, getFollowersCount, updateFavourite} from '@/libs/api/api'
import {cloneDeep, isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'
import DetailMenu from '@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue'

export default {
    name: 'Dossier',
    components: {
        DetailMenu,
        'List': () => import('@/components/pages/InformationPortal/ProfilePage/Collections/List/List.vue')
    },
    props: {
        module: {
            type: String
        },
        updateLeftMenu: {
            type: Function,
            default: () => {}
        },
        updateCount: {
            type: Function,
            default: () => {}
        },
        // left menu
        details: {
            type: Object,
            default: () => {}
        },
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        followUnfollowAction: {
            type: Function,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        followersCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        isDossier: {
            type: Boolean,
            default: false
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        routeToAboutPage: {
            type: Function,
            default: () => {}
        },
        fetchMetaDetails: {
            type: Function,
            default: () => {}
        }
    },
    mounted () {
        this.getMetaDossierListing()
    },
    data() {
        return {
            isEmpty,
            isArticles: false,
            dossierList: [],
            dossierListResult: {},
            dossierListToDisplay: [],
            searchValue: '',
            skip: 0,
            limit: 30,
            order: 'desc',
            sort: 'createdAt',
            isFetching: false,
            currentPage: 1
        }
    },
    methods: {
        /**
         * to get the listing of A/P/P
         */
        getMetaDossierListing () {
            // fetch collections
            this.fetchMetaDossiers(this.skip, this.limit, this.order, this.sort)
        },

        /**
         * fetch the collections for A/P/P
         */
        fetchMetaDossiers (skip, limit, order, sort) {
            this.isFetching = true
            // params for api
            let params = {
                skip, limit, sort, order
            }
            // body for api
            let body = {
                entity_id: this.$route.params.id,
                entity_type: this.module
            }
            // api call
            getMetaDossierList(body, params).then(response => {
                this.dossierList = cloneDeep(response.items || [])
                this.dossierListToDisplay = cloneDeep(response.items || [])
                this.dossierListResult = cloneDeep(response || {})
                this.isFetching = false
            }).catch(() => {
                this.isFetching = false
            })
        },
        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the articles
            this.getMetaDossierListing()
        },
        /**
         * emitted function to route to detail page of collection
         * @param {*} list 
         */
        routeToDossierDetailPage: async function (list) {
            await this.$router.push({name: `${this.module.toLowerCase()}-dossiers-page`, params: {id: this.$route.params.id, did: list._id}})
            // to update the left side menu in detail page for dossier
            this.updateLeftMenu(false, list)
        },
        followDossierList (list) {
            loader(this, true)
            // body for api
            let body = {
                entity_type: constants.LIST.DOSSIER,
                entity_id: list._id,
                catalog_id: getCatalogId()
            }
            // api call
            followCollection(body, list.is_following ? 'unfollow' : 'follow').then(async () => {
                // to update the list
                let dossierList = cloneDeep(this.dossierList)
                dossierList.map(dossier => {
                    if (dossier.id === list.id) dossier.is_following = !dossier.is_following
                    return dossier
                })
                this.dossierList = dossierList
                // to show the updated result
                this.dossierListToDisplay = cloneDeep(this.dossierList)
                // body for followers count
                let bodyToSend = {
                    entity_type: constants.LIST.DOSSIER,
                    entity_id: list._id
                }
                // api call
                let response = await getFollowersCount(bodyToSend)
                // update the count in the listing
                this.updateDossierListCount(list, response)
                // to update the count of followers
                this.updateCount(constants.LIST.COLLECTION,response)
                message(this, constants.messageType.SUCCESS, `${list.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`)
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to update count of collection list count result
         * @param {*} list 
         * @param {*} result 
         */
        updateDossierListCount (list, result) {
            let dossierListToDisplay = cloneDeep(this.dossierListToDisplay)
            this.dossierListToDisplay = dossierListToDisplay.map(dossier => {
                if (dossier._id === list._id) dossier.followers_count = result.count
                return dossier
            })
        },
        /**
         * to get the favorite for collection/dossier
         */
        getDossierFavorite (list) {
            // to check for collection/dossier
            if (list && list.favorites && new Set(list.favorites).has(this.$store.getters.getUserInformation.id)) return true
            // to check for detail page(A/P/P)
            else return false
        },

        /**
         * create/delete favorite for collection and dossier
         */
        async setDossierFavorite (list) {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getDossierFavorite(list)
                let body = {
                    entity_type: constants.LIST.DOSSIER,
                    entity_id: list._id
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                // assigning updated favorites
                list['favorites'] = response.result.favorites
                // updating the whole list
                this.updateDossierFavorite(list)
                // message
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * to update the listing
         * @param {*} list 
         */
        updateDossierFavorite (list) {
            let dossierListToDisplay = cloneDeep(this.dossierListToDisplay)
            this.dossierListToDisplay = dossierListToDisplay.map(dossier => {
                if (dossier._id === list._id) dossier.favorites = list.favorites
                return dossier
            })
        }
    }
}